import React, { useState, useEffect } from 'react';
import { useLoadingScreen } from '../../Store/LoadingManager';

import { useNavigate } from "react-router-dom";
import { useSnackbar } from 'notistack';
import { Button, Box } from "@mui/material";

import { IconEye, IconEyeOff } from '@tabler/icons-react';

import { AuthFooterContainer } from '../../Styles/Authentication/authenticationStyles';


import { StaticDisplayText } from '../../Constants/StaticDisplayTexts';

export default function AuthFooter() {
    return <AuthFooterContainer>
        <div className="footerText">{StaticDisplayText.COPYRIGHTS}</div>
        <div className="footerText">{StaticDisplayText.POWERED_BY}</div>
        <div className="footerText">{StaticDisplayText.VERSION_NUM}</div>
    </AuthFooterContainer>
}